<template>
    <transition>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="page-title-box">
                        <div class="page-title-right float-left">
                            <ol class="breadcrumb m-0"> 
                                <li class="breadcrumb-item active">Reports </li>
                                <li class="breadcrumb-item"><a href="javascript: void(0);">Ledger Report</a></li>
                                
                            </ol>
                        </div>
                        <div class="page-title-right float-right "> 
                            <!-- <button type="button" class="btn btn-primary float-right" @click="toggleModal">
                              Add New
                            </button>  -->
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 ">
                    <div class="card">
                        <div class="card-header">
                            <h3 style="text-align: center;">Ledger Report</h3>
                        </div>

                        <div class="card-body">
                            
                            <div class="row mb-3">
                                <div class="form-group col-md-3">
                                    <label for="company_id">Company *</label><br>
                                    <Multiselect 
                                        class="form-control border company_id" 
                                        mode="single"
                                        v-model="search_terms.company_id"
                                        placeholder="Company Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="company_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                        @change="changeCompany"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.company_id">
                                        {{errors.company_id[0]}}
                                    </div>
                                </div>
                                <div class="form-group col-md-3">
                                    <label for="profit_center_id">Profit Center </label><br>
                                    <Multiselect 
                                        class="form-control border profit_center_id" 
                                        mode="single"
                                        v-model="search_terms.profit_center_id"
                                        placeholder="Profit Center Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="profit_center_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                        @change="changeProfitCenter"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.profit_center_id">
                                        {{errors.profit_center_id[0]}}
                                    </div>
                                </div>                          
                                <div class="form-group col-md-3">
                                    <label for="cost_center_id">Cost Center </label><br>
                                    <Multiselect 
                                        class="form-control border cost_center_id" 
                                        mode="single"
                                        v-model="search_terms.cost_center_id"
                                        placeholder="Cost Center Select"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="cost_center_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.cost_center_id">
                                        {{errors.cost_center_id[0]}}
                                    </div>
                                </div>

                                <div class="col-md-3">
                                    <div class="">
                                        <label for="ledger_id"> Ledger *</label><br>
                                        <treeselect 
                                            v-model="search_terms.ledger_id"
                                            :multiple="false" 
                                            :always-open="false"
                                            :options="ledgers"
                                            :normalizer="normalizer"
                                            :value-consists-of="valueConsistsOf"
                                            :default-expand-level="Infinity"
                                            :search-nested="true"     
                                            @select="onkeyPress('ledger_id')"                                           
                                            placeholder='Select Ledger account'
                                            v-if="renderOptionComponent"
                                        />
                                        <div class="invalid-feedback" v-if="errors.ledger_id">
                                            {{errors.ledger_id[0]}}
                                        </div>
                                    </div>
                                </div>
            
                            </div>
                            <div class="row">                                

                                <div class="col-md-3">
                                    <label for="fiscal_year_id">Fiscal Year *</label><br>
                                    <Multiselect 
                                        class="form-control border fiscal_year_id" 
                                        mode="single"
                                        v-model="search_terms.fiscal_year_id"
                                        placeholder="Select Fiscal Year"  
                                        :searchable="true" 
                                        :filter-results="true"
                                        :options="fiscal_year_options"
                                        :classes="multiclasses"
                                        :close-on-select="true" 
                                        :min-chars="1"
                                        :resolve-on-load="false"
                                    /> 
                                    <div class="invalid-feedback" v-if="errors.fiscal_year_id">
                                        {{errors.fiscal_year_id[0]}}
                                    </div>
                                </div>

                                

                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="from_date"> From Date *</label>
                                        <input type="date" class="form-control" id="from_date" :min="fiscal_year_start_date" :max="search_terms.to_date" v-model="search_terms.from_date" @change="onkeyPress('from_date')">
                                        <div class="invalid-feedback" v-if="errors.from_date">
                                            {{errors.from_date[0]}}
                                        </div>
                                    </div>
                                </div>       

                                <div class="col-md-3">
                                    <div class="mb-3">
                                        <label for="to_date"> To Date *</label>
                                        <input type="date" class="form-control" id="to_date" :min="search_terms.from_date" :max="fiscal_year_end_date" v-model="search_terms.to_date" @change="onkeyPress('to_date')">
                                        <div class="invalid-feedback" v-if="errors.to_date">
                                            {{errors.to_date[0]}}
                                        </div>
                                    </div>
                                </div>       

                                <div class="col-md-3">
                                    <div class="mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="disabled" @click="filterLedgerReport()">
                                            <span v-show="isSubmit">
                                                <i class="fas fa-spinner fa-spin" ></i>
                                            </span>Submit 
                                        </button>
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class=" btn btn-primary" @click.prevent="printItem(item)" ><i class="mdi mdi-printer-outline me-1"></i> </a>
                                    
                                        <a href="javascript:void(0);" style="margin-left: 5px;" class="btn btn-primary"
                                        @click.prevent="downloading ? null : exportToExcel()">
                                            <span v-show="downloading"  >
                                                <i class="fas fa-spinner fa-spin"></i>
                                            </span> 
                                            <i class="mdi mdi-file-excel me-1"></i> 
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card"> 
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-bordered table-centered w-100" v-if="!loading">
                                    <thead class="table-light">
                                        <tr class="success item-head">
                                            <th width="5%" style="text-align: center">SL</th>
                                            <th width="10%" style="text-align: center">Date</th>
                                            <th width="15%" style="text-align: center">Voucher Code</th>
                                            <th width="30%" style="text-align: center">Account Head</th>
                                            <!-- <th width="15%" style="text-align: center">Narration/Cheque Details </th> -->
                                            <th width="10%" style="text-align: center">Debit Amount</th>
                                            <th width="10%" style="text-align: center">Credit Amount</th>
                                            <th width="10%" style="text-align: center">Balance</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        <tr v-if="search_terms.ledger_id != null">
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>Opening Balance</td>
                                            <!-- <td></td> -->
                                            <td></td>
                                            <td></td>
                                            <td class="text-right">{{ formatNumberWithDecimals(opening_balance, 2) }}</td>
                                        </tr>
                                        <!-- <template v-for="(item, i) in items" :key="i">
                                            <template v-if="item.recursion.length > 0"> -->
                                                <!-- <tr v-for="(ledger, j) in item.recursion" :key="j"> -->
                                                <tr v-for="(ledger, index) in newItemAry" :key="index">
                                                    <td class="text-center">{{ index + 1 }}</td>
                                                    <td class="text-center">{{ ledger.vdate }}</td>
                                                    <td class="text-center">{{ ledger.voucher_code }}</td>
                                                    <td class="text-left" style="word-wrap: break-word; max-width: 400px;">{{ ledger.ledger_details }}</td>
                                                    <!-- <td>{{ ledger.global_note }}</td>  -->
                                                    <td class="text-right" v-if="ledger.pvaccount_type == 'dr'">{{ formatNumberWithDecimals(ledger.credit, 2) }}</td>
                                                    <td class="text-right" v-else> --- </td>
                                                    <td class="text-right" v-if="ledger.pvaccount_type == 'cr'">{{ formatNumberWithDecimals(ledger.debit, 2) }}</td>
                                                    <td class="text-right" v-else>----</td>
                                                    <td class="text-right"> {{ formatNumberWithDecimals(ledger.balance_amount, 2) }}</td>
                                                </tr>                                               
                                            <!-- </template>                                        
                                        </template> -->
                                    
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colspan="4" class="text-center">Total </th>
                                            <th class="text-right">{{ balance('dr') }}</th>
                                            <th class="text-right">{{ balance('cr') }}</th>
                                            <th class="text-right">{{ formatNumberWithDecimals(row_available_balance, 2) }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>

                            <div class="tab-pane show active" v-if="loading">
                                <div class="row"> 
                                    <div class="col-md-5">  
                                    </div>
                                    <div class=" col-md-2"> 
                                        <img src="../../assets/image/loading.gif" alt="Loading..." style="width:130px">
                                    </div>
                                    <div class="col-md-5">  
                                    </div>
                                </div>
                            </div>

                        </div> 
                    </div>

                    <Modal @close="toggleModal()"  >
                        <div class="modal-content scrollbar-width-thin orderPreview" >
                            <div class="modal-header"> 
                                <button @click="toggleModal()" type="button" class="btn btn-default">X</button>
                                <h3 style="width: 100%">Ledger Report</h3>
                            </div>
                            <div class="modal-body " id="printArea" >
                                <div class="table-responsive product_table">
                                    <table class="table po_invoice">
                                        <tr>
                                            <td colspan="2" class="text-center" style="position: relative;">
                                                <h5 class="text-uppercase">{{ this.retailShopName }}</h5>
                                                <p>{{ this.retailShopAddress }} </p>
                                                <p>Dhaka, Bangladesh</p> 
                                                <h4 style="text-align: center;">Ledger Report</h4>
                                                <h4 style="text-align: center;">{{ supplier_name }}</h4>
                                                <h4 style="text-align: center;">From {{ search_terms.from_date }} TO {{ search_terms.to_date }}</h4>  
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="table table-bordered table-centered w-100" v-if="!loading">
                                        <thead class="table-light">
                                            <tr class="success item-head">
                                                <th width="5%" style="text-align: center">SL</th>
                                                <th width="10%" style="text-align: center">Date</th>
                                                <th width="15%" style="text-align: center">Voucher Code</th>
                                                <th width="30%" style="text-align: center">Account Head</th>
                                                <!-- <th width="15%" style="text-align: center">Narration/Cheque Details </th> -->
                                                <th width="15%" style="text-align: center">Debit Amount</th>
                                                <th width="15%" style="text-align: center">Credit Amount</th>
                                                <th width="10%" style="text-align: center">Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-if="search_terms.ledger_id != null">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Opening Balance</td>
                                                <!-- <td></td> -->
                                                <td></td>
                                                <td></td>
                                                <td style="text-align: right;">{{ formatNumberWithDecimals(opening_balance, 2) }}</td>
                                            </tr> 
                                            <tr v-for="(ledger, index) in newItemAry" :key="index">
                                                <td class="text-center">{{ index + 1 }}</td>
                                                <td class="text-center">{{ ledger.vdate }}</td>
                                                <td class="text-center">{{ ledger.voucher_code }}</td>
                                                <td class="text-left" style="word-wrap: break-word; max-width: 400px !important;">{{ ledger.ledger_details }}</td>
                                                <!-- <td>{{ ledger.global_note }}</td>  -->
                                                <td style="text-align: right;" v-if="ledger.pvaccount_type == 'dr'">{{ formatNumberWithDecimals(ledger.credit, 2) }}</td>
                                                <td style="text-align: right;" v-else> --- </td>
                                                <td style="text-align: right;" v-if="ledger.pvaccount_type == 'cr'">{{ formatNumberWithDecimals(ledger.debit, 2) }}</td>
                                                <td style="text-align: right;" v-else>----</td>
                                                <td style="text-align: right;"> {{ formatNumberWithDecimals(ledger.balance_amount, 2) }}</td>
                                            </tr>                                         
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <th colspan="4" class="text-center">Total </th>
                                                <th style="text-align: right;">{{ balance('dr') }}</th>
                                                <th style="text-align: right;">{{ balance('cr')  }}</th>
                                                <th style="text-align: right;">{{ formatNumberWithDecimals(row_available_balance, 2) }}</th>
                                            </tr>
                                        </tbody>
                                    </table> 
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>        
        </div>
    </transition>
</template>
<script>
import Modal from "./../helper/Modal";
import { ref, onMounted } from "vue";
import axios from 'axios';
import Form from 'vform';

import AccountTrialBalanceVue from "@/components/AccountTrialBalance";

export default {
    name: 'PosLeftbar',
    components: {
        Modal,
        AccountTrialBalanceVue
    },
    data() {
        return {
            newItemAry:[],
            sl:1,
            loading: true,
            downloading: false,
            isSubmit: false,
            disabled: false,
            showModal: false,
            modalActive:false,
            errors: {},
            companies: [],
            company_options: [],
            profit_centers: [],
            profit_center_options: [],
            cost_centers: [],
            cost_center_options: [],
            fiscal_years: [],
            fiscal_year_options: [],
            fiscal_year_start_date: '',
            fiscal_year_end_date: '',
            items: [],
            ledgers: [],
            ledger_options: [],
            ledger_id: null,
            renderOptionComponent: true,
            valueConsistsOf: 'BRANCH_PRIORITY',
            normalizer(node) {
                return {
                    id: node.id,
                    label: '['+ node.code +'] '+ node.name,
                    children: node.children,
                }
            },
            total_opening_balance: 0,
            total_debit_balance: 0,
            total_credit_balance: 0,
            total_closing_balance: 0,
            search_terms: new Form({
                company_id: '',
                profit_center_id: '',
                cost_center_id: '',
                fiscal_year_id: '',
                from_date: '',
                to_date: '',
                ledger_id: null,
            }),
            opening_balance: 0,
            debit_amount_action: 1,
            credit_amount_action: -1,
            row_balance: 0,
            row_available_balance: 0,
            from_date: '',
            to_date: '',
            show_with_code: false,
            codeActive: false,
            multiclasses: { 
                clear: '',
                clearIcon: '', 
            },
        };
    },
    created() {
        this.fetchAccountLedgers();
        this.fetchCompany();
        this.fetchProfitCenters();
        this.fetchFiscalYear();
        this.newItemAry = [];
    },
    methods: { 
        balance: function(type){
            let sum = 0;
            this.items.filter((item) => {
                item.recursion.filter((ledger) => {
                    if(type=='dr'){
                        sum += Number(ledger.credit);
                    }else{
                        sum += Number(ledger.debit);
                    }
                    
                });
            })
            return this.formatNumberWithDecimals(Number(sum), 2);
        },

        toggleModal: function() {
            this.modalActive = !this.modalActive;  
            this.errors = '';
            this.isSubmit = false;
        },

        fetchCompany() { 
            axios.get(this.apiUrl+'/companies', this.headerjson)
            .then((res) => {
                this.companies = res.data.data;
                this.company_options = [{label: "Select Company", value: ""}];
                res.data.data.map((item) => {
                    this.company_options.push({label: item.name, value: item.id});
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }); 
        },

        fetchProfitCenters() { 
            axios.get(this.apiUrl+'/profit_centers/list', this.headerjson)
            .then((res) => {
                this.profit_centers = res.data.data;
                this.profit_center_options = res.data.data.map((item) => {
                    return {label: item.name, value: item.id};
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }); 
        },

        changeProfitCenter(value) {
            var profit_center_id = value;
            this.fetchCostCenters(profit_center_id);
        },

        fetchCostCenters(profit_center_id='') { 
            this.cost_center_options = [];
            this.search_terms.cost_center_id = null;
            axios.get(this.apiUrl+'/cost_centers', this.headerjson)
            .then((res) => {
                this.cost_centers = res.data.cost_centers;
                if(profit_center_id) {
                    this.cost_center_options = res.data.data.cost_centers.filter((item) => item.profit_center_id == profit_center_id).map((item) => {
                        return {label: item.center_name, value: item.id};
                    });
                }else{      
                    this.cost_center_options = []
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            }); 
        },

        changeCompany(value) {
            var company_id = value;
            this.fetchActiveFiscalYear(company_id);
        },

        fetchActiveFiscalYear(comapny_id='') {
            this.search_terms.fiscal_year_id = null; 
            this.search_terms.from_date = '';
            this.search_terms.to_date = '';
            this.fiscal_year_start_date = '';
            this.fiscal_year_end_date = '';

            if(comapny_id == '') {
                return false;
            }
            let formData = new Form({
                company_id: comapny_id,
            });
            axios.post(this.apiUrl+'/fiscal_years/getActiveFiscalYear', formData, this.headerjson) 
            .then((resp) => {
                let fiscal_year = resp.data.data;
                if(fiscal_year) {
                    this.search_terms.fiscal_year_id = fiscal_year.id;
                    this.search_terms.from_date = fiscal_year.start_date;
                    this.search_terms.to_date = fiscal_year.end_date;
                    this.fiscal_year_start_date = fiscal_year.start_date;
                    this.fiscal_year_end_date = fiscal_year.end_date;
                }else{
                    this.search_terms.fiscal_year_id = '';
                    this.search_terms.from_date = '';
                    this.search_terms.to_date = '';
                    this.fiscal_year_start_date = '';
                    this.fiscal_year_end_date = '';
                }
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        fetchFiscalYear() {
            axios.get(this.apiUrl+'/fiscal_years', this.headerjson) 
            .then((resp) => {
                this.fiscal_years = resp.data.data;        
                this.fiscal_year_options = resp.data.data.map((item) => {
                    return {label: item.label, value: item.id};
                });
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message);
            });
        },

        fetchAccountLedgers() {
            axios.get(this.apiUrl+'/account_ledgers/getChartOfAccountsOnlyLedgerOption', this.headerjson)
            .then((resp) => {
                this.ledgers = resp.data.data.accounts;  
            })
            .catch((err) => {
                this.$toast.error(err.response.data.message)
            })
            .finally(() => {
                this.loading = false;
            });
        },

        filterLedgerReport() {
            this.isSubmit = true;
            this.disabled = true;
            if(this.search_terms.company_id == '') {
                this.errors.company_id = ['Company is required'];
            }else if(this.search_terms.fiscal_year_id == '') {
                this.errors.fiscal_year_id = ['Fiscal Year is required'];
            }else {
                this.errors = {};
            }
            if(Object.keys(this.errors).length > 0) {
                this.disabled = false;
                this.isSubmit = false;
                return false;
            }else{
                this.disabled = true;
                this.isSubmit = true;
            }

            this.fetchLedgerReport();
        },

        fetchLedgerReport() { 
            this.loading = true;
            this.newItemAry = [];
            var data = {
                company_id: this.search_terms.company_id,
                profit_center_id: this.search_terms.profit_center_id,   
                cost_center_id: this.search_terms.cost_center_id,
                fiscal_year_id: this.search_terms.fiscal_year_id,
                ledger_id: this.search_terms.ledger_id, 
                from_date: this.search_terms.from_date, 
                to_date: this.search_terms.to_date
            };
            // axios.post(this.apiUrl+'/reports/ledger-report', data, this.headerjson)
            axios.post(this.apiUrl+'/reports/ledger-report-new', data, this.headerjson)
            .then((res) => {
                console.log("report_data", res.data.data.report_data);
                this.items = res.data.data.report_data;
                this.opening_balance = res.data.data.opening_balance;
                this.row_available_balance = res.data.data.opening_balance;
                this.debit_amount_action = res.data.data.debit_amount_action;
                this.credit_amount_action = res.data.data.credit_amount_action;

                
                var initial_balance = res.data.data.opening_balance;
                var balance_amount = 0;
                // newItemAry
                this.items.filter((row, index) => { 
                    if(row.recursion.length> 0){
                        this.row_available_balance = res.data.data.opening_balance;
                        row.recursion.filter((child, cindex) => {
                            child.vdate = row.vdate;
                            child.voucher_code = row.voucher_code;
                            child.global_note = row.global_note;
                            child.pvaccount_type = row.vaccount_type;
                            if(row.vaccount_type == "dr") {
                                let damount = (parseFloat(child.credit) * (this.debit_amount_action));
                                // balance_amount = (this.row_available_balance + (damount));
                                balance_amount = (initial_balance + (damount));
                            }else{
                                let camount = (parseFloat(child.debit) * (this.credit_amount_action));
                                // balance_amount = (this.row_available_balance + (camount));
                                balance_amount = (initial_balance + (camount));
                            }

                            child.balance_amount = parseFloat(balance_amount).toFixed(4); 
                            initial_balance = balance_amount;
                            this.row_available_balance = balance_amount;
                            // Push new Item 
                            this.newItemAry.push(child);
                        });
                    }
                });
                this.isSubmit = false;
                // this.disabled = true;
            })
            .catch((err) => { 
                this.isSubmit = false;
                this.disabled = false;
                this.$toast.error(err.response.data.message);
            }).finally((ress) => {
                this.loading = false;
                this.disabled = false;
            });
        },


        
        checkRequiredPrimary()
        {
            // if(this.search_terms.ledger_id) {
            //     this.disabled = false;
            // }else{
            //     this.disabled = true;
            // }
        },
        onkeyPress: function(field) { 
            this.checkRequiredPrimary();
            for (var k in this.errors){     // Loop through the object
                if(k==field){      // If the current key contains the string we're looking for 
                    delete this.errors[k];  // Delete obj[key];
                }
            }  
        },

        showLedgerCode: function(event) {
            var checked_val = this.show_with_code;
            if(checked_val) {
                this.codeActive = true;
            }else{
                this.codeActive = false;
            }
        },
        printItem: function () {   
            this.printContent('printArea');
        },

        printContent(document_id) { 
            const options = {
                name: '_blank',
                specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
                styles: [ 
                    this.baseUrlPrintCSS+'/assets/css/bootstrap-print.min.css',
                    this.baseUrlPrintCSS+'/assets/css/print.css'
                ],
            };
            this.$htmlToPaper(document_id, options);
        },
        
        // Export Ledger Statement 
        async exportToExcel() {
            let searchQuery = {
                'company_id': this.search_terms.company_id,
                'profit_center_id': this.search_terms.profit_center_id,
                'cost_center_id': this.search_terms.cost_center_id,
                'fiscal_year_id': this.search_terms.fiscal_year_id,
                'ledger_id': this.search_terms.ledger_id,
                'from_date': this.search_terms.from_date,
                'to_date': this.search_terms.to_date,
                'report_type': 'ledger_statement',  
            }
            const queryString = this.objectToQueryString(searchQuery); 

            this.downloading = true; 

            const query = queryString;
            try {
                // const response = await axios.get(`${this.apiUrl}/reports/ledger-report-export${query}`, {
                const response = await axios.get(`${this.apiUrl}/reports/ledger-report-export-new${query}`, {
                responseType: 'blob', // Important: set the response type to 'blob'
                headers: {
                    'Authorization' : this.$store.getters.token ? `Bearer ${this.$store.getters.token}` : "",
                    Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' // Specify the expected content type
                }
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ledger-statement.xlsx');
                document.body.appendChild(link);
                link.click();
                this.downloading = false;
            } catch (error) { 
                this.$toast.error(error.message);
                this.downloading = false;
            }
        },

        objectToQueryString: function (obj) {   
            const queryString = Object.keys(obj)
                .filter((key) => obj[key] !== undefined) // Exclude undefined values
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
                .join('&');
            return `?${queryString}`;
        }, 


    },

    destroyed() {},
    mounted() {
        window.scrollTo(0, 0);
    },
    computed: {}
}
</script>
<style scoped>
.modal-content.scrollbar-width-thin {
    border: none !important;
    width: 90%;
    display: block;
    margin: 0 auto;
}

label {
    display: inline-block;
    margin: 0px 0px 4px 2px;
    float: left;
}

.invalid-feedback {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
    text-align: left;
}

.actions a{
    margin-right: 5px;
}
</style>